import { baseApi } from "./baseApi";
import {
  SigninRequest,
  SignoutRequest,
  ForgetPasswordRequest,
  VerificationRequest,
  ResetPasswordRequest,
  CreateVerificationRequest,
} from "../../interfaces";

const resetSessionCache = (
  dispatch: (action: unknown) => void,
  queryFulfilled: Promise<unknown>,
) =>
  queryFulfilled
    .then(() => {
      dispatch(baseApi.util.resetApiState());
    })
    .catch(() => {
      dispatch(baseApi.util.resetApiState());
    });

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    signin: builder.mutation<any, SigninRequest>({
      query: (data) => ({
        url: "/api/v2/auth/signin",
        method: "POST",
        body: data,
      }),
    }),
    signout: builder.mutation<any, SignoutRequest>({
      query: (data) => ({
        url: "/api/auth/signout",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["LiveLecture", "TeacherSchedule", "Account"],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        resetSessionCache(dispatch, queryFulfilled);
      },
    }),
    forgetPassword: builder.mutation<any, ForgetPasswordRequest>({
      query: (data) => ({
        url: "/api/v2/auth/forget-password",
        method: "POST",
        body: data,
      }),
    }),
    verifyOtp: builder.mutation<any, VerificationRequest>({
      query: (data) => ({
        url: "/api/v2/auth/verify",
        method: "POST",
        body: data,
      }),
    }),
    resetPassword: builder.mutation<any, ResetPasswordRequest>({
      query: (data) => ({
        url: "/api/v2/auth/forget-password/reset-password",
        method: "POST",
        body: data,
      }),
    }),
    resendOtp: builder.mutation<any, CreateVerificationRequest>({
      query: (data) => ({
        url: "/api/verification/resend",
        method: "POST",
        body: data,
      }),
    }),
    changeUserPassword: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/auth/change-password",
        method: "PATCH",
        body: data,
      }),
    }),
  }),
});

export const {
  useSigninMutation,
  useSignoutMutation,
  useForgetPasswordMutation,
  useVerifyOtpMutation,
  useResetPasswordMutation,
  useResendOtpMutation,
  useChangeUserPasswordMutation,
} = authApi;
